import { render, staticRenderFns } from "./FormAreaPromoter.vue?vue&type=template&id=88f87f74&scoped=true"
import script from "./FormAreaPromoter.vue?vue&type=script&lang=js"
export * from "./FormAreaPromoter.vue?vue&type=script&lang=js"
import style0 from "./FormAreaPromoter.vue?vue&type=style&index=0&id=88f87f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f87f74",
  null
  
)

export default component.exports